import { checkTranslated } from './helpers';

export function nFormatter(num: any, decimal?: number): number | string {
  let isNegative = false;
  if (num < 0) {
    isNegative = true;
    num *= -1;
  }
  if (isNaN(num)) return num;
  num = Number(num);
  if (!isFinite(num)) {
    return num;
  }

  const decimalPlace = decimal ? decimal : 1;
  let formattedNumber;
  num = Math.abs(num);
  if (num >= 1000000000000) {
    formattedNumber =
      (num / 1000000000000)?.toFixed(1).replace(/\.0$/, '') + 'T';
  } else if (num >= 1000000000) {
    formattedNumber = (num / 1000000000)?.toFixed(1).replace(/\.0$/, '') + 'B';
  } else if (num >= 1000000) {
    formattedNumber =
      (num / 1000000)?.toFixed(decimalPlace).replace(/\.0$/, '') + 'M';
  } else if (num >= 1000) {
    formattedNumber =
      (num / 1000)?.toFixed(decimalPlace).replace(/\.0$/, '') + 'K';
  } else {
    formattedNumber = num;
  }
  return isNegative
    ? checkTranslated(`-${formattedNumber}`, `${formattedNumber}-`)
    : formattedNumber;
}
